/**
 * An immutable data class to hold the classic form supported features
 *
 * It is introduced as the same properties in the classic form have been polluted and
 * there is no ways to trace the original value.
 *
 * So, `readonly` must be applied to all properties.
 *
 * NOTE: The class has been defined a specific data structure and used in {@link ClassicFormControls}.
 * Please do not convert the class to an interface.
 * Please do not define any business logic into this class.
 */
export class ClassicFormSettingsHolder {
	constructor(
		public readonly canAdd: boolean,
		public readonly canSave: boolean,
		public readonly canDelete: boolean,
		public readonly hasAuditDetails: boolean,
		public readonly hasNotes: boolean, // TODO to add more controls here
	) {}
}
